export enum UserRole {
  CUSTOMER = 'customer',
  FARMER = 'farmer',
  DELIVERY_AGENT = 'delivery_agent',
  SUPPLIER = 'supplier',
  ADMIN = 'admin',
}

// Backend user response (snake_case)
export interface UserBackendResponse {
  id: string;
  email: string;
  phone: string;
  first_name: string;
  last_name: string;
  role: UserRole;
  profile_image?: string;
  is_verified: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// Frontend user object (camelCase for consistency)
export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  phoneNumber?: string;
  profileImage?: string;
  isEmailVerified: boolean;
  /** Account/farmer verification status (drives the dashboard verification nudge). */
  isVerified: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateUserDto {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  profileImage?: string;
}
